<template>
  <div class="ThreeBox">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @changeCompany="changeCompany" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick"></tab-tree>
      </div>
      <div class="grid-rightcontent">
        <btn-show @show="Btn" content="左边树"></btn-show>
        <el-row :gutter="14" class="top">
          <el-col :span="11" class="topleft">
            <check-result :checkResult="checkResult" :ifQualified="ifQualified" :ifLoad="ifLoad"></check-result>
          </el-col>
          <el-col :span="13" class="topright">
            <un-balanced :tableData="tableData" :ifLoad="ifLoad"></un-balanced>
          </el-col>
        </el-row>
        <el-row :gutter="14" class="bottom">

          <el-col :span="24" class="bottomright">
            <real-time :selectedMeasure="selectedMeasure"></real-time>
          </el-col>
        </el-row>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from '@/components/common/TabTree.vue'
import BtnShow from '@/components/common/BtnShow.vue'
import api from '@common/api/index.js'
import { findDataByParam } from '@/utils/index.js'
import handleData from '@/utils/handleData.js'
import CheckResult from '@/components/page/ThreeDegreesOfUnbalance/CheckResult.vue'
import UnBalanced from '@/components/page/ThreeDegreesOfUnbalance/UnBalanced.vue'
import RealTime from '@/components/page/ThreeDegreesOfUnbalance/RealTime.vue'
import Phase from '@/components/page/ThreeDegreesOfUnbalance/Phase.vue'
import ResizeContainer from "@/components/common/resizeContainer.vue";
export default {
  components: {
    TabTree,
    BtnShow,
    CheckResult,
    UnBalanced,
    RealTime,
    Phase,
    ResizeContainer
  },
  data () {
    return {
      //   width: 350,
      width: 209,
      activecode: '',
      tabShow: true,
      tableData: [],
      viewTreeData: [],
      selectedMeasure: {
        measureId: '',
        measureName: ''
      },
      plqxdata: '',
      //检查结果
      checkResult: [],
      //检查结果
      ifLoad: true,
      ifQualified: '合格'
    }
  },
  created () {
    let vm = this
    vm.selectedTab = 'voltage'
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () { },
  methods: {
    changeCompany (companyId) {
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/power/ThreeDegreesOfUnbalance', null)
        .then(res => {
          const viewTreeData = findDataByParam('viewTree', true, res.data)
          this.viewTreeData = viewTreeData
        })
    },
    //调接口拿取数据
    getData () {
      let vm = this
      vm.activecode = 0
      vm.checkResult = [{ value: 50, name: '完成率' }]
      vm.ifLoad = true
      //三相不平衡
      vm.$api.tmp
        .getThreePhaseUnbalance(vm.selectedMeasure.measureId)
        .then(resArr => {
          if (resArr.success) {
            let tableData = JSON.parse(JSON.stringify(resArr.data.unbalance))
            let phasePie = []

            vm.ifQualified = '合格'
            tableData.map(item => {
              item.assess = item.assess == '' ? '-' : item.assess
              item.maximum = item.maximum == '' ? '-' : item.maximum
              item.maximumTime = item.maximumTime == '' ? '-' : item.maximumTime
              item.maximum = item.maximum == '' ? '-' : item.maximum
              item.standardValue = item.standardValue == '' ? '-' : '<=' + item.standardValue + '%'
              item.realTimePercent = item.realTimePercent == '' ? '-' : item.realTimePercent + '%'
              if (item.assess == '不合格') {
                vm.ifQualified = '不合格'
              }
            })
            vm.ifLoad = false

            vm.tableData = tableData
          } else {
            vm.$message.error(resArr.msg)
          }
        })
        .catch(error => {
          vm.$message.error(error.msg)
        })
    },
    Btn () {
      let vm = this
      vm.tabShow = !vm.tabShow
      vm.getData()
    },
    //默认加载事件
    tabTreeDefault (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
    tabTreeClick (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/threeDegreesOfUnbalance.scss"; //引入外部样式
.ThreeBox {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
}
.person {
  height: 100%;
}
.grid-rightcontent {
  position: relative;
  height: 100%;
  color: rgba(24, 24, 24, 1);
  display: flex;
  flex-flow: column;
}
.tree-content {
  width: 100%;
  margin-right: 14px;
}
.top {
  position: absolute;
  left: 0;
  right: 0;
}
.table {
  margin: 10px;
}
.bottom {
  position: absolute;
  top: 259px;
  left: 0;
  right: 0;
  bottom: 0;
}
// ::v-deep .tabTree-wrap[data-v-bd1aa9c2] {
//   background: #fff;
// }
.hglfont {
  // width: 53px;
  // height: 26px;
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #206ee3;
  display: flex;
  justify-content: center;
}
.littletitle {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
::v-deep .el-table .warning-row {
  background-color: #fafbfb !important;
}

::v-deep .el-table .success-row {
  background: #fff !important;
}
.bottomright {
  height: 100%;
}
</style>
